// extracted by mini-css-extract-plugin
export default {"container":"B8UDhon5IgcA5HSPNLEAy"};